import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { PoweredByLuminary } from '@/components/brand/PoweredByLuminary/PoweredByLuminary';
import { Button } from '@/components/form/baseInputs/Button';

export interface ErrorOverlayProps {
  heading: React.ReactNode;
  body: React.ReactNode;
  showLogo?: boolean;
  showBackButton?: boolean;
}

export function ErrorOverlay({
  body,
  heading,
  showLogo = true,
  showBackButton,
}: ErrorOverlayProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const isBackButtonClicked = useRef(false);

  // A ref lets cleanup read the latest flag without waiting for a render.
  useEffect(() => {
    return () => {
      // if the back button is clicked, force a reload so the user is pushed to the latest version
      if (isBackButtonClicked.current) {
        window.location.reload();
      }
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.dark,
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Stack maxWidth={600} textAlign="center" spacing={2}>
        <Typography variant="title-xl" color={theme.palette.common.white}>
          {heading}
        </Typography>
        <Typography variant="body-s" color={theme.palette.common.white}>
          {body}
        </Typography>

        {showBackButton && (
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              isBackButtonClicked.current = true;
              navigate(-1);
            }}
          >
            Go back
          </Button>
        )}
      </Stack>
      {showLogo && (
        <Box mt={6} maxWidth={200}>
          <PoweredByLuminary />
        </Box>
      )}
    </Box>
  );
}
